import { Injectable } from '@angular/core';
import { AuthenticateApiService } from './authenticate-api.service';
import { TokenService } from './token.service';

const HEARTBEAT_INTERVAL_MS = 2 * 60 * 1000;

// Pings the server (see StaffController.OnlineThreshold) roughly every 2min while
// the tab is visible, so the Staff list "online" badge reflects real activity
// instead of just an unexpired token. Paused in background tabs so switching
// away doesn't keep someone looking "online" indefinitely.
@Injectable({
    providedIn: 'root',
})
export class PresenceService {

    private intervalId: any = null;
    private readonly visibilityListener = () => this.onVisibilityChange();

    constructor(
        private authenticateApiService: AuthenticateApiService,
        private tokenService: TokenService,
    ) { }

    start(): void {
        if (this.intervalId) return;

        document.addEventListener('visibilitychange', this.visibilityListener);
        this.sendHeartbeat();
        this.intervalId = setInterval(() => this.sendHeartbeat(), HEARTBEAT_INTERVAL_MS);
    }

    stop(): void {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
        document.removeEventListener('visibilitychange', this.visibilityListener);
    }

    private onVisibilityChange(): void {
        if (document.visibilityState === 'visible') {
            this.sendHeartbeat();
        }
    }

    private sendHeartbeat(): void {
        if (document.visibilityState !== 'visible') return;
        if (!this.tokenService.getAccessToken()) return;

        this.authenticateApiService.Heartbeat().subscribe({ error: () => { } });
    }
}
